import { useEffect } from 'react'
import { Layout, notification } from 'antd'
import { Outlet } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../hooks'

import { getMarketplace, setMarketplaceFilters } from '../Services/MarketplaceService'
import { setAllMarketplace } from '../Slices/ConfigurationSlice'
import { PostObjParameters } from '../Constants/Configuration'
import { isFromIntegration, handleErrorCatchLog, sendMessage, renderTranslation } from '../Helpers/GenericHelpers'
import { getPricelists } from '../Services/PricelistService'
import { getProfileOptions } from '../Services/ConfigurationService'
import { getTokenFromSessionStorage } from '../Helpers/TokenHelper'
import Header from '../Components/Generic/Header'
import SideNavigation from '../Components/Generic/SideNavigation'
import ThemeButton from '../Components/Generic/ThemeButton'
import { formatString } from 'Helpers/StringHelpers'
import { TranslationKeys } from 'Constants/TranslationKeys'
import { useNavigateWrapper } from 'Helpers/NavigateHelper'

function Home() {
  const dispatch = useAppDispatch()
  const serverConfig = useAppSelector(state => state.present.article.serverConfig)
  const token = getTokenFromSessionStorage()
  const importedSubRule = useAppSelector(state => state.present.subRule.importedSubRule)
  const language = useAppSelector(state => state.present.language.value)
  const navigationWrapper = useNavigateWrapper()

  useEffect(() => {
    if (importedSubRule.ruleId !== 0)
      notification.open({
        description: (
          <div
            style={{ fontWeight: 'bolder', textDecoration: 'underline', cursor: 'pointer' }}
            onClick={() => navigationWrapper.navigateToSubrule(importedSubRule.ruleId)}
          >
            {' '}
            {renderTranslation(language, TranslationKeys.importExcelNotifyClick)}
          </div>
        ),
        message: formatString(renderTranslation(language, TranslationKeys.importExcelNotify), importedSubRule.ruleName),
      })
  }, [importedSubRule])

  useEffect(() => {
    if (serverConfig && token) {
      dispatch(getProfileOptions()).then(appVersion => {
        if (isFromIntegration(window)) {
          sendMessage({ value: appVersion, type: 'Version' })
        }
      })

      dispatch(getMarketplace)
        .then((data: any) => {
          if (data && data.length !== 0) {
            dispatch(setAllMarketplace(data))
            dispatch(setMarketplaceFilters)
          }
          dispatch(getPricelists()).then(() => {
            if (isFromIntegration(window)) {
              //send parameter message to check it there's mdId or vaId to receive. This is primary related to GRUCCIA behavior
              sendMessage({ next: PostObjParameters, type: 'Sincro' })
            }
          })
        })
        .catch(err => {
          handleErrorCatchLog(err, 'Failed loading marketplace getMarketplace')
        })
    }
  }, [dispatch, serverConfig, token])

  return (
    <Layout className='page-layout' style={{ minHeight: '100vh', maxHeight: '100%' }}>
      <Header />
      <Layout>
        <SideNavigation />
        <Outlet />
      </Layout>
      <ThemeButton />
    </Layout>
  )
}

export default Home
